/** Notifications tab — web mirror of `Sources/Views/NotificationsView.swift`.
 * The recent `factory_events` feed, newest first. */

import { useAppState } from '../app/context';
import { EmptyState, relativeShort } from '../components/UIHelpers';
import { jsonDisplayString, type FactoryEventRow } from '../models/factory';

export function NotificationsView() {
  const { snapshot } = useAppState();
  const events = [...snapshot.events].sort((a, b) => Date.parse(b.event_ts) - Date.parse(a.event_ts));

  return (
    <section className="section">
      <div className="card">
        {events.length === 0 ? (
          <EmptyState icon="🔕" title="No events" message="Factory events will appear here as the engine emits them." />
        ) : null}
        {events.map((ev) => (
          <EventRow key={ev.id} event={ev} />
        ))}
      </div>
    </section>
  );
}

function iconFor(type: string): string {
  if (type.startsWith('task.failed')) return '⚠';
  if (type.startsWith('task.done')) return '✓';
  if (type.startsWith('task.')) return '⚙';
  if (type.startsWith('pr.')) return '⑃';
  if (type.startsWith('approval.')) return '✋';
  if (type.startsWith('chat.') || type.startsWith('command.')) return '💬';
  if (type === 'heartbeat') return '⚡';
  return '•';
}

function tintFor(type: string): string {
  if (type.startsWith('task.failed')) return 'var(--red)';
  if (type.startsWith('task.done')) return 'var(--green)';
  if (type.startsWith('pr.')) return 'var(--purple)';
  if (type.startsWith('approval.')) return 'var(--orange)';
  if (type === 'heartbeat') return 'var(--green)';
  return 'var(--blue)';
}

function EventRow({ event }: { event: FactoryEventRow }) {
  return (
    <div className="row row__head" style={{ alignItems: 'flex-start' }}>
      <span style={{ color: tintFor(event.type), width: 22, textAlign: 'center' }}>{iconFor(event.type)}</span>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div className="row__head">
          <span className="row__title" style={{ fontSize: 14 }}>
            {event.type}
          </span>
          {event.scope ? <span className="caption">· {event.scope}</span> : null}
          <span className="row__spacer" />
          <span className="caption">{relativeShort(event.event_ts)}</span>
        </div>
        <div className="row__subtitle">{jsonDisplayString(event.payload)}</div>
      </div>
    </div>
  );
}
